import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { TableAnimationState } from "src/util/types/components/sfxTable"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableTrSkeleton',
  props: {
  animationStart: {
    type: String as PropType<TableAnimationState>,
    required: true,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const animationClass = computed<string>(() => {
  let className = "sfx-table__tr-animate-"
  switch (props.animationStart) {
    case "start":
    default:
      className += "start"
      break
    case "middle":
      className += "middle"
      break
    case "end":
      className += "end"
      break
  }

  return className
})

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["sfx-table__tr sfx-table__tr-animate", animationClass.value])
  }, null, 2))
}
}

})